import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { RxCross2 } from "react-icons/rx";
import Swal from "sweetalert2";

import { FaArrowLeft, FaPray } from "react-icons/fa";
import { useSelector } from "react-redux";
import BASE_API_URL from "../../../../api/api";
import apiInstance from "../../../../Utils/api";
const Top = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 30px;
`;

const Center = styled.div`
  flex: 1;
  display: inline;
  text-align: center;
`;

const Button = styled.button`
  background: rgb(0, 7, 51);
  color: white;
  justify-content: center;
  padding: 5px 30px;
  border: none;
  border-radius: 10px;
  margin-top: 20px;
`;

const Title = styled.h5`
  font-weight: bold;
  margin-top: 10px;
`;
const Div = styled.div``;
const Label = styled.label``;
const Input = styled.input`
  width: 100%;
`;
const Span = styled.span`
  color: red;
`;
const Textarea = styled.textarea``;

const Select = styled.select`
  padding: 5px 7px;
  border-radius: 5px;
`;
const Option = styled.option``;

const Table = styled.table``;
const Thead = styled.thead``;
const Tbody = styled.tbody``;
const Tr = styled.tr`
  text-align: center;
`;
const Th = styled.th`
  font-size: 15px;
`;
const Td = styled.td`
  font-size: 14px;
`;

const Create = () => {
  const token = localStorage.getItem("token");
  const url = BASE_API_URL;
  const api = apiInstance;

  const [doctors, setDoctors] = useState([]);

  const [stockTranData, setStockTranData] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [machines, setMachines] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [medicineList, setMedicineList] = useState([]);
  const [items, setItems] = useState([]);
  const [isGenItem, setIsGenItem] = useState(false);
  const [isItem, setIsItem] = useState(false);
  const [id, setId] = useState("");
  const [accitems, setAccItems] = useState([]);
  const [isAccItem, setIsAccItem] = useState(false);
  const [accid, setAccId] = useState("");
  const [macitems, setMacItems] = useState([]);
  const [isMacItem, setIsMacItem] = useState(false);
  const [medItems, setMedItems] = useState([]);
  const [isMedItem, setIsMedItem] = useState(false);
  const [qty, setQty] = useState("");

  const [branchID, setBranchID] = useState("");
  const [upBranchID, setUpBranchID] = useState("");
  const [upBranchName, setUpBranchName] = useState("");
  const [branchLists, setBranchLists] = useState([]);
  const [generalList, setGeneralList] = useState();

  const [date, setDate] = useState("");
  const [relatedBranch, setRelatedBranch] = useState("");
  const [reqNo, setReqNo] = useState("");
  const [reqBy, setReqBy] = useState("");

  const [upProData, setUpProData] = useState([]);
  const [upMedData, setUpMedData] = useState([]);
  const [upProAcc, setUpProAcc] = useState([]);
  const [upGen, setUpGen] = useState([]);

  //Pro Medicine
  const [tableProData, setTableProData] = useState([]);
  const [selectOption, setSelectOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableMedData, setTableMedData] = useState([]);
  const [selectMedOption, setSelectMedOption] = useState({
    id: "",
    name: "",
  });

  //Medicine
  const [tableProAccData, setTableProAccData] = useState([]);
  const [selectProAccOption, setSelectProAccOption] = useState({
    id: "",
    name: "",
  });
  //General
  const [tableGenData, setTableGenData] = useState([]);
  const [selectGenOption, setSelectGenOption] = useState({
    id: "",
    name: "",
  });

  const Id = useLocation().pathname.split("/")[2];

  useEffect(() => {
    const getMedicine = async () => {
      const res = await api.get("medicine-items");
      setMedicineList(res.data.list);
    };

    const getProcedures = async () => {
      const res = await api.get("procedure-items");
      setProcedures(res.data.list);
    };
    const getAccessories = async () => {
      const res = await api.get("accessory-items");
      console.log(res.data.list);
      setAccessories(res.data.list);
    };
    const getGeneral = async () => {
      const res = await api.get("general-items");
      console.log(res.data.list);
      setGeneralList(res.data.list);
    };
    const getBranch = async () => {
      const res = await api.get("branches");
      console.log(res.data.list);
      setBranchID(res.data.list[0]._id);
      setBranchLists(res.data.list);
    };

    const getStockTranList = async () => {
      try {
        const res = await api.get("stock-transfer/" + Id);

        console.log(res.data.data[0], "ST");
        setStockTranData(res.data.data[0]);
        setReqNo(res.data.data[0].requestNo);
        setReqBy(res.data.data[0].requestedBy);
        setUpBranchID(res.data.data[0].relatedBranch._id);
        setUpBranchName(res.data.data[0].relatedBranch.name);
        setDate(res.data.data[0].date?.split("T")[0]);
        //NOTE For Meducine
        if (
          res.data.data[0].medicineLists !== null &&
          res.data.data[0].medicineLists.length > 0
        ) {
          const newData = res.data.data[0].medicineLists.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.medicineItemName : "",
              item_id: data.item_id,
              stockQty: data.stockQty,
              requestedQty: data.requestedQty,
              purchasePrice: data.purchasePrice,
              totalPrice: data.totalPrice,
              transferQty: data.transferQty,
            };
          });
          setUpMedData(newData);
          setIsMedItem(true);
        }
        //NOTE For Procedure Medicine
        if (
          res.data.data[0].procedureMedicine !== null &&
          res.data.data[0].procedureMedicine.length > 0
        ) {
          const newData = res.data.data[0].procedureMedicine.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.procedureItemName : "",
                item_id: data.item_id,
                stockQty: data.stockQty,
                requestedQty: data.requestedQty,
                purchasePrice: data.purchasePrice,
                totalPrice: data.totalPrice,
                transferQty: data.transferQty,
              };
            },
          );
          setUpProData(newData);
          setIsItem(true);
        }
        //NOTE For Procedure Accessory
        if (
          res.data.data[0].procedureAccessory !== null &&
          res.data.data[0].procedureAccessory.length > 0
        ) {
          const newData = res.data.data[0].procedureAccessory.map(
            (data, index) => {
              return {
                id: index,
                name: data.item_id ? data.item_id.accessoryItemName : "",
                item_id: data.item_id,
                stockQty: data.stockQty,
                requestedQty: data.requestedQty,
                purchasePrice: data.purchasePrice,
                totalPrice: data.totalPrice,
                transferQty: data.transferQty,
              };
            },
          );
          setUpProAcc(newData);
          console.log(newData, "Pro Acc");
          setIsAccItem(true);
        }
        //NOTE For General
        if (
          res.data.data[0].generalItems !== null &&
          res.data.data[0].generalItems?.length > 0
        ) {
          console.log(res.data.data[0], "geennn");
          const newData = res.data.data[0].generalItems.map((data, index) => {
            return {
              id: index,
              name: data.item_id ? data.item_id.generalItemName : "",
              item_id: data.item_id,
              stockQty: data.item_id.currentQuantity,
              requestedQty: data.requestedQty,
              purchasePrice: data.purchasePrice,
              totalPrice: data.totalPrice,
              transferQty: data.transferQty,
            };
          });
          setUpGen(newData);

          console.log(newData, "Gen");
          setIsGenItem(true);
        }
      } catch (err) {
        alert(err.message);
      }
    };

    getMedicine();
    getGeneral();
    getStockTranList();
    getProcedures();
    getAccessories();
    getBranch();
  }, []);

  //Start procedure medicine add row

  //NOTE Input Changes when input qty and per usage qty
  const handleProInputChange = (event, id, field) => {
    const newData = tableProData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAddRow = (id, name) => {
    // console.log(name, 'Pro name')
    setTableProData([
      ...tableProData,
      {
        id: tableProData.length + 1,
        name: name,
        item_id: id,
        stockQty: 3,
        requestedQty: "",
        transferQty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proName = selectedOption.getAttribute("data-name");
    setSelectOption({
      id: id,
      name: proName,
    });

    // const value = event.target.value
    // // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', proName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeProcedure = (id) => {
    setTableProData(tableProData.filter((el) => el.item_id != id));
  };
  //End procedure medicine add row

  //Start Medicine add row
  //NOTE Input Changes when input qty and per usage qty
  const handleMedInputChange = (event, id, field) => {
    const newData = tableMedData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableMedData(newData);
  };

  const handleGenInputChange = (event, id, field) => {
    const newData = tableGenData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableGenData(newData);
  };

  //NOTE to delete proecedure medicine
  const removeGen = (index) => {
    setTableGenData(tableGenData.filter((el, ind) => ind !== index));
  };
  //NOTE to add row of Procedure Medicine
  const handleMedAddRow = (id, name) => {
    // console.log(name, 'Med name')
    setTableMedData([
      ...tableMedData,
      {
        id: tableMedData.length + 1,
        name: name,
        item_id: id,
        stockQty: 3,
        requestedQty: "",
        transferQty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsMedItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleMedGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const medName = selectedOption.getAttribute("data-name");
    setSelectMedOption({
      id: id,
      name: medName,
    });

    // Use the id, name, and value as needed
    // console.log('ID:', id)
    // console.log('Name:', medName)
    // console.log('Value:', value)
  };

  //NOTE to delete proecedure medicine
  const removeMedicine = (id) => {
    setTableMedData(tableMedData.filter((el) => el.item_id != id));
  };

  //End Medicine add row

  //Start ProAccessory add row
  //NOTE Input Changes when input qty and per usage qty
  const handleProAccInputChange = (event, id, field) => {
    const newData = tableProAccData.map((data) => {
      if (data.id === id) {
        return { ...data, [field]: event.target.value };
      }
      return data;
    });
    console.log(newData);
    setTableProAccData(newData);
  };

  //NOTE to add row of Procedure Medicine
  const handleProAccAddRow = (id, name) => {
    console.log(name, "proAcc name");
    setTableProAccData([
      ...tableProAccData,
      {
        id: tableProAccData.length + 1,
        name: name,
        item_id: id,
        stockQty: 3,
        requestedQty: "",
        transferQty: "",
      },
    ]);

    // console.log(proMedName, 'pro med')
    setIsAccItem(true);
  };

  //NOTE to get Id and Name of procedure medicine
  const handleProAccGet = (event) => {
    const { options, selectedIndex } = event.target;
    const selectedOption = options[selectedIndex];
    const id = selectedOption.getAttribute("data-id");

    const proAccName = selectedOption.getAttribute("data-name");
    setSelectProAccOption({
      id: id,
      name: proAccName,
    });

    const value = event.target.value;
    // Use the id, name, and value as needed
    console.log("ID:", id);
    console.log("Name:", proAccName);
    console.log("Value:", value);
  };

  //NOTE to delete proecedure medicine
  const removeProAcc = (id) => {
    setTableProAccData(tableProAccData.filter((el) => el.item_id != id));
  };

  //End Medicine add row

  //End add table row and delete
  const update = () => {
    const data = {
      id: Id,
      date: date,

      //   relatedBranch: branchID,
      requestNo: reqNo,
      requestedBy: reqBy,
      //   medicineLists: tableMedData,
      //   procedureMedicine: tableProData,
      //   procedureAccessory: tableProAccData,

      status: true,
    };

    if (upBranchID) {
      data.relatedBranch = upBranchID;
    } else {
      data.relatedBranch = branchID;
    }

    if (upProData) {
      data.procedureMedicine = [...upProData, ...tableProData];
    } else {
      data.procedureMedicine = tableProData;
    }

    if (upMedData) {
      data.medicineLists = [...upMedData, ...tableMedData];
    } else {
      data.medicineLists = tableMedData;
    }

    if (upProAcc) {
      data.procedureAccessory = [...upProAcc, ...tableProAccData];
    } else {
      data.procedureAccessory = tableProAccData;
    }

    // alert(JSON.stringify(data))

    api
      .put("stock-transfer", data)
      .then(function (response) {
        Swal.fire({
          title: "Sorry!",
          text: "Full your Transfer Qty",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      })
      .catch(function (err) {
        Swal.fire({
          title: "Something Wrong!",
          text: "Try again, Please.",
          icon: "warning",
          // showCancelButton: true,

          cancelButtonText: "Close",
        });
      });
  };
  return (
    <>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-12">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/stock-tran">
                        <i>
                          <FaArrowLeft />
                        </i>
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      Stock Transfer Detail
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>

          <section className="content">
            <div className="container-fluid">
              <div className="card-body row border border-dark">
                <h5>Transfer Detail</h5>
                <div className="offset-2 col-8 py-5">
                  <div className="row">
                    <div className="col-6 form-group ">
                      <Label>
                        Date<Span>*</Span>
                      </Label>
                      <Input
                        type="date"
                        className="form-control"
                        disabled
                        value={date}
                        onChange={(e) => setDate(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <div className="col-md-6 ">
                      <div class="form-group">
                        <label for="name">Branches</label>
                        <Input
                          type="text"
                          className="form-control"
                          style={{ borderRadius: "15px" }}
                          disabled
                          value={upBranchName}
                        />
                        {/* <select
                          class='custom-select border-info'
                          name='account_type_id'
                          id='cat'
                          style={{ borderRadius: '15px' }}
                          onChange={e => {
                            setBranchID(e.target.value)
                            setUpBranchID(e.target.value)
                          }}
                          
                        >
                          <option value={upBranchID} disabled>{upBranchName}</option>
                          {branchLists.map(option => (
                            <option value={option._id}>{option.name}</option>
                          ))}
                        </select> */}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group ">
                      <Label>
                        Request No:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        defaultValue={stockTranData?.transferNo}
                        disabled
                        // onChange={(e) => setReqNo(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <div className="col-6 form-group">
                      <Label>
                        Request By:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        defaultValue={stockTranData?.transferBy}
                        disabled
                        // onChange={(e) => setReqBy(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-6 form-group ">
                      <Label>
                        Issue No:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        defaultValue={reqNo}
                        disabled
                        onChange={(e) => setReqNo(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                    <div className="col-6 form-group">
                      <Label>
                        Issue By:<Span>*</Span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        defaultValue={reqBy}
                        disabled
                        onChange={(e) => setReqBy(e.target.value)}
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <h4 className="text-decoration-underline">Medicine</h4>
                  </div>

                  <div className="col-12 mt-3">
                    <Table className="table">
                      <Thead>
                        <Tr>
                          {/* <Th>No.</Th> */}
                          <Th>Item Name</Th>

                          <Th>Stock Qty</Th>

                          <Th>Requested Qty</Th>
                          <Th>Transfer Qty</Th>
                          <Th>Total Amount</Th>
                          <Th>Unit</Th>
                        </Tr>
                      </Thead>
                      {isMedItem && (
                        <Tbody>
                          {upMedData &&
                            upMedData.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}
                                <Td>{item.name}</Td>
                                <Td>
                                  {/* <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleMedInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                /> */}
                                  {item.stockQty}
                                </Td>
                                {/* <Td>{procedure.purchasePrice}</Td> */}
                                <Td>
                                  {/* <input
                                    type='number'
                                    defaultValue={item.requestedQty}
                                    style={{ borderRadius: '10px' }}
                                    className='text-center'
                                    onChange={event =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        'requestedQty'
                                      )
                                    }
                                  /> */}
                                  {item.requestedQty}
                                </Td>

                                <Td>
                                  {/* <input
                                    type='number'
                                    defaultValue={item.transferQty}
                                    style={{ borderRadius: '10px' }}
                                    className='text-center'
                                    onChange={event =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        'transferQty'
                                      )
                                    }
                                  /> */}
                                  {item.transferQty}
                                </Td>
                                <Td>{item.totalPrice}</Td>
                                <Td>{item.item_id?.unit}</Td>
                                {/* <Td>
                                  <RxCross2
                                    onClick={() => removeMedicine(item.item_id)}
                                  />
                                </Td> */}
                              </Tr>
                            ))}
                          {tableMedData.map((item, index) => (
                            <Tr>
                              {/* <Td>{++index}</Td> */}
                              <Td>{item.name}</Td>
                              <Td>
                                {/* <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleMedInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                /> */}
                                3
                              </Td>
                              {/* <Td>{procedure.purchasePrice}</Td> */}
                              <Td>
                                <input
                                  type="number"
                                  defaultValue={item.requestedQty}
                                  style={{ borderRadius: "10px" }}
                                  onChange={(event) =>
                                    handleMedInputChange(
                                      event,
                                      item.id,
                                      "requestedQty",
                                    )
                                  }
                                />
                              </Td>

                              <Td>
                                <input
                                  type="number"
                                  defaultValue={item.transferQty}
                                  style={{ borderRadius: "10px" }}
                                  className="text-center"
                                  onChange={(event) =>
                                    handleMedInputChange(
                                      event,
                                      item.id,
                                      "transferQty",
                                    )
                                  }
                                />
                              </Td>
                              <Td>{item.totalPrice}</Td>
                              <Td>
                                <RxCross2
                                  onClick={() => removeMedicine(item.item_id)}
                                />
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>

                  {/* NOTE Procedure Medicine */}
                  <div className="row">
                    <h4 className="text-decoration-underline">
                      Procedure Medicine
                    </h4>
                  </div>

                  <div className="col-12 mt-4">
                    <Table className="table">
                      <Thead>
                        <Tr>
                          {/* <Th>No.</Th> */}
                          <Th>Item Name</Th>

                          <Th>Stock Quantity</Th>

                          <Th>Requested Quantity</Th>
                          <Th>Transfer Qty</Th>
                          <Th>Total Amount</Th>
                          <Th>Unit</Th>
                        </Tr>
                      </Thead>
                      {isItem && (
                        <Tbody>
                          {upProData &&
                            upProData.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}
                                <Td>{item.name}</Td>
                                {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                                <Td>{item.stockQty}</Td>
                                <Td>
                                  {/* <input
                                    type='number'
                                    style={{ borderRadius: '15px' }}
                                    defaultValue={item.requestedQty}
                                    onChange={event =>
                                      handleProInputChange(
                                        event,
                                        item.id,
                                        'requestedQty'
                                      )
                                    }
                                    className='text-center'
                                  /> */}
                                  {item.requestedQty}
                                </Td>

                                <Td>
                                  {/* <input
                                    type='number'
                                    defaultValue={item.transferQty}
                                    style={{ borderRadius: '10px' }}
                                    className='text-center'
                                    onChange={event =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        'transferQty'
                                      )
                                    }
                                  /> */}
                                  {item.transferQty}
                                </Td>
                                <Td>{item.totalPrice}</Td>
                                <Td>{item.item_id?.unit}</Td>

                                {/* <Td>
                                  <RxCross2
                                    onClick={e => removeProcedure(item.item_id)}
                                  />
                                </Td> */}
                              </Tr>
                            ))}
                          {tableProData.map((item, index) => (
                            <Tr>
                              {/* <Td>{++index}</Td> */}
                              <Td>{item.name}</Td>
                              {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                              <Td>3</Td>
                              <Td>
                                <input
                                  type="number"
                                  style={{ borderRadius: "15px" }}
                                  defaultValue={item.requestedQty}
                                  onChange={(event) =>
                                    handleProInputChange(
                                      event,
                                      item.id,
                                      "requestedQty",
                                    )
                                  }
                                  className="size-10"
                                />
                              </Td>

                              <Td>
                                <input
                                  type="number"
                                  defaultValue={item.transferQty}
                                  style={{ borderRadius: "10px" }}
                                  className="text-center"
                                  onChange={(event) =>
                                    handleMedInputChange(
                                      event,
                                      item.id,
                                      "transferQty",
                                    )
                                  }
                                />
                              </Td>
                              <Td>{item.totalPrice}</Td>

                              <Td>
                                <RxCross2
                                  onClick={(e) => removeProcedure(item.item_id)}
                                />
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>
                  {/* NOTE End Procedure Medicine */}

                  <div className="row">
                    <h4 className="text-decoration-underline">
                      Procedure Accessory
                    </h4>
                  </div>
                  <div className="col-12 mt-3">
                    <Table className="table">
                      <Thead>
                        <Tr>
                          <Th>Item Name</Th>

                          <Th>Stock Quantity</Th>

                          <Th>Requested Quantity</Th>
                          <Th>Transfer Qty</Th>
                          <Th>Total Amount</Th>
                          <Th>Unit</Th>
                        </Tr>
                      </Thead>
                      {isAccItem && (
                        <Tbody>
                          {upProAcc &&
                            upProAcc.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}
                                <Td>{item.name}</Td>
                                {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                                <Td>{item.stockQty}</Td>
                                <Td>
                                  {/* <input
                                    type='number'
                                    style={{ borderRadius: '15px' }}
                                    defaultValue={item.requestedQty}
                                  
                                    className='text-center disable'
                                    onChange={event =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        'requestedQty'
                                      )
                                    }
                                  /> */}
                                  {item.requestedQty}
                                </Td>

                                <Td>
                                  {/* <input
                                    type='number'
                                    defaultValue={item.transferQty}
                                    style={{ borderRadius: '10px' }}
                                    className='text-center'
                                    onChange={event =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        'transferQty'
                                      )
                                    }
                                  /> */}
                                  {item.transferQty}
                                </Td>
                                <Td>{item.totalPrice}</Td>
                                <Td>{item.item_id?.unit}</Td>

                                {/* <Td>
                                  <RxCross2
                                    onClick={() => removeProAcc(item.item_id)}
                                  />
                                </Td> */}
                              </Tr>
                            ))}

                          {tableProAccData.map((item, index) => (
                            <Tr>
                              {/* <Td>{++index}</Td> */}
                              <Td>{item.name}</Td>
                              {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                              <Td>3</Td>
                              <Td>
                                <input
                                  type="number"
                                  style={{ borderRadius: "15px" }}
                                  defaultValue={item.perUsageQTY}
                                  onChange={(event) =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      "requestedQty",
                                    )
                                  }
                                  className="size-10"
                                />
                              </Td>

                              <Td>
                                <input
                                  type="number"
                                  defaultValue={item.transferQty}
                                  style={{ borderRadius: "10px" }}
                                  className="text-center"
                                  onChange={(event) =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      "transferQty",
                                    )
                                  }
                                />
                              </Td>
                              <Td>
                                <RxCross2
                                  onClick={() => removeProAcc(item.item_id)}
                                />
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>
                  {/* NOTE End Procedure Accessory */}

                  <div className="row">
                    <h4 className="text-decoration-underline">General Items</h4>
                  </div>
                  <div className="col-12 mt-3">
                    <Table className="table">
                      <Thead>
                        <Tr>
                          <Th>Item Name</Th>

                          <Th>Stock Quantity</Th>

                          <Th>Requested Quantity</Th>
                          <Th>Transfer Qty</Th>
                          <Th>Total Amount</Th>
                          <Th>Unit</Th>
                        </Tr>
                      </Thead>
                      {isGenItem && (
                        <Tbody>
                          {upGen &&
                            upGen.map((item, index) => (
                              <Tr>
                                {/* <Td>{++index}</Td> */}
                                <Td>{item.name}</Td>
                                {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                                <Td>{item.stockQty}</Td>
                                <Td>
                                  {/* <input
                                    type='number'
                                    style={{ borderRadius: '15px' }}
                                    defaultValue={item.requestedQty}
                                  
                                    className='text-center disable'
                                    onChange={event =>
                                      handleProAccInputChange(
                                        event,
                                        item.id,
                                        'requestedQty'
                                      )
                                    }
                                  /> */}
                                  {item.requestedQty}
                                </Td>

                                <Td>
                                  {/* <input
                                    type='number'
                                    defaultValue={item.transferQty}
                                    style={{ borderRadius: '10px' }}
                                    className='text-center'
                                    onChange={event =>
                                      handleMedInputChange(
                                        event,
                                        item.id,
                                        'transferQty'
                                      )
                                    }
                                  /> */}
                                  {item?.transferQty}
                                </Td>
                                <Td>{item?.totalPrice}</Td>
                                <Td>{item.item_id?.unit}</Td>

                                {/* <Td>
                                  <RxCross2
                                    onClick={() => removeProAcc(item.item_id)}
                                  />
                                </Td> */}
                              </Tr>
                            ))}

                          {tableGenData.map((item, index) => (
                            <Tr>
                              {/* <Td>{++index}</Td> */}
                              <Td>{item.name}</Td>
                              {/* <Td>
                                <input
                                  type='number'
                                  // defaultValue={procedure.qty}
                                  defaultValue={item.quantity}
                                  onChange={event =>
                                    handleProAccInputChange(
                                      event,
                                      item.id,
                                      'quantity'
                                    )
                                  }
                                  className='size-10'
                                />
                              </Td> */}
                              <Td>3</Td>
                              <Td>
                                <input
                                  type="number"
                                  style={{ borderRadius: "15px" }}
                                  defaultValue={item.perUsageQTY}
                                  onChange={(event) =>
                                    handleGenInputChange(
                                      event,
                                      item.id,
                                      "requestedQty",
                                    )
                                  }
                                  className="size-10"
                                />
                              </Td>

                              <Td>
                                <input
                                  type="number"
                                  defaultValue={item.transferQty}
                                  style={{ borderRadius: "10px" }}
                                  className="text-center"
                                  onChange={(event) =>
                                    handleGenInputChange(
                                      event,
                                      item.id,
                                      "transferQty",
                                    )
                                  }
                                />
                              </Td>
                              <Td>
                                <RxCross2
                                  onClick={() => removeGen(item.item_id)}
                                />
                              </Td>
                            </Tr>
                          ))}
                        </Tbody>
                      )}
                    </Table>
                  </div>
                  {/* NOTE End Procedure Accessory */}
                </div>
              </div>
              <Top>
                <div className="row mb-3" style={{ marginLeft: "430px" }}>
                  {/* <div className='col-md-5'>
                    <Button
                      style={{ backgroundColor: 'pink', color: 'black' }}
                      onClick={update}
                    >
                      Submit
                    </Button>
                  </div> */}
                  <div className="col-md-4">
                    <Link
                      to="/stock-req"
                      className="btn btn-sm px-3 py-1"
                      style={{
                        borderRadius: "10px",
                        marginTop: "1.7em",
                        fontSize: "12px",
                        backgroundColor: "pink",
                      }}
                    >
                      Cancel
                    </Link>
                  </div>
                  <div className="offset-3 col-3">
                    <Link
                      to={"/show-tran-print/" + Id}
                      style={{
                        borderRadius: "10px",
                        marginTop: "1.5em",
                        width: "65px",
                        fontSize: "13px",
                        backgroundColor: "pink",
                      }}
                      className="btn btn-sm mb-2"
                    >
                      Print
                    </Link>
                  </div>
                </div>
              </Top>
            </div>
          </section>
        </div>

    </>
  );
};

export default Create;
